/* Nitroma oil finder UI. Requires nitroma-finder-rules.js (loaded first). */
(function () {
  'use strict';
  var cfg = window.NitromaFinder || {};
  var API = (cfg.apiUrl || '').replace(/\/+$/, '');
  var FINDER_URL = cfg.finderUrl || '/pages/oil-finder';
  var STORE_KEY = 'nitroma_vehicle';
  var YEAR_NOW = new Date().getFullYear();
  var R = window.NitromaRules;
  if (!R) return;
  var MANUAL_MAKES = R.MANUAL_MAKES, makeGroup = R.makeGroup, fuelKind = R.fuelKind, recommend = R.recommend;

  /* --------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanReg(r) { return String(r || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8); }
  function prettyReg(r) { r = cleanReg(r); return r.length === 7 ? r.slice(0, 4) + ' ' + r.slice(4) : r; }
  function titleCase(s) { return String(s || '').toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/\bBmw\b/, 'BMW').replace(/\bMini\b/, 'MINI').replace(/\bVw\b/, 'VW').replace(/\bDs\b/, 'DS').replace(/\bMg\b/, 'MG').replace(/\bSeat\b/, 'SEAT'); }
  function gradeHandle(g) { return String(g).toLowerCase(); }
  function collUrl(r) { return '/collections/' + r.collection + '/' + gradeHandle(r.grade); }
  function saveVehicle(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} renderHeaderPill(); }
  function loadVehicle() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function clearVehicle() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} renderHeaderPill(); }
  function vehicleLabel(v) { var bits = []; if (v.year) bits.push(v.year); bits.push(titleCase(v.make)); if (v.model) bits.push(titleCase(v.model)); return bits.join(' '); }
  function vehicleSub(v) { var bits = []; if (v.cc) bits.push((v.cc / 1000).toFixed(1).replace(/\.0$/, '.0') + 'L'); if (v.fuel) bits.push(titleCase(v.fuel)); if (v.colour) bits.push(titleCase(v.colour)); return bits.join(' · '); }

  function normaliseVehicle(raw, reg) {
    var make = String(raw.make || '').toUpperCase();
    var v = {
      reg: reg ? cleanReg(reg) : '',
      make: make,
      model: raw.model || '',
      year: parseInt(raw.yearOfManufacture || raw.year, 10) || 0,
      fuel: fuelKind(raw.fuelType || raw.fuel),
      cc: parseInt(raw.engineCapacity || raw.cc, 10) || 0,
      colour: raw.colour || '',
      type: 'car'
    };
    var wp = String(raw.wheelplan || '').toUpperCase();
    if (wp.indexOf('2 WHEEL') === 0 || wp.indexOf('3 WHEEL') === 0) v.type = 'motorcycle';
    if ((raw.revenueWeight && raw.revenueWeight > 3500) || /RIGID BODY|ARTIC/.test(wp)) v.type = 'truck';
    v.group = makeGroup(make);
    return v;
  }

  function lookup(reg) {
    reg = cleanReg(reg);
    if (!API) return Promise.reject({ code: 'no_api' });
    if (!/^[A-Z0-9]{2,8}$/.test(reg)) return Promise.reject({ code: 'bad_reg' });
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 12000);
    return fetch(API + '/lookup?reg=' + encodeURIComponent(reg), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
      .then(function (res) {
        if (timer) clearTimeout(timer);
        if (!res.ok || !res.body || res.body.error) throw { code: res.status === 404 ? 'not_found' : 'api', message: res.body && res.body.error };
        return normaliseVehicle(res.body, reg);
      });
  }

  /* --------------------------------------------------------- header pill */
  function renderHeaderPill() {
    var host = $('.header__icons');
    if (!host) return;
    var pill = $('.n-header-vehicle', host);
    var v = loadVehicle();
    if (!v) { if (pill) pill.remove(); return; }
    if (!pill) {
      pill = document.createElement('a');
      pill.className = 'n-header-vehicle';
      pill.href = FINDER_URL;
      host.insertBefore(pill, host.firstChild);
    }
    pill.innerHTML = (v.reg ? '<span class="n-plate-mini">' + esc(prettyReg(v.reg)) + '</span>' : '') + '<span>' + esc(vehicleLabel(v)) + '</span><button type="button" aria-label="Remove saved vehicle" title="Remove">&times;</button>';
    pill.classList.add('is-visible');
    $('button', pill).addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clearVehicle(); });
  }

  /* ------------------------------------------------------ plate forms */
  function bindPlateForms() {
    $$('form[data-n-plate-form]').forEach(function (form) {
      var input = $('input', form);
      if (input) input.addEventListener('input', function () { var p = input.selectionStart; input.value = input.value.toUpperCase().replace(/[^A-Z0-9 ]/g, ''); try { input.setSelectionRange(p, p); } catch (e) {} });
      form.addEventListener('submit', function (e) {
        var mode = form.getAttribute('data-n-plate-form');
        if (mode === 'finder' || mode === 'fit') return; /* handled by finder page / fit box */
        e.preventDefault();
        var reg = cleanReg(input && input.value);
        if (!reg) { if (input) input.focus(); return; }
        window.location.href = FINDER_URL + '?reg=' + encodeURIComponent(reg);
      });
    });
  }

  /* ------------------------------------------------------- finder page */
  function initFinder(root) {
    var regForm = $('form[data-n-plate-form="finder"]', root);
    var regInput = regForm && $('input', regForm);
    var status = $('[data-n-status]', root);
    var result = $('[data-n-result]', root);
    var manual = $('[data-n-manual]', root);
    var makeSel = $('[data-n-make]', root), fuelSel = $('[data-n-fuel]', root), yearSel = $('[data-n-year]', root), ccInput = $('[data-n-cc]', root);
    var tabs = $$('[data-n-tab]', root), panes = $$('[data-n-pane]', root);
    var noApi = !API;

    MANUAL_MAKES.forEach(function (m) { var o = document.createElement('option'); o.value = m; o.textContent = m; makeSel.appendChild(o); });
    for (var y = YEAR_NOW + 1; y >= 1990; y--) { var oy = document.createElement('option'); oy.value = y; oy.textContent = y; yearSel.appendChild(oy); }

    function showTab(name) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-n-tab') === name); t.setAttribute('aria-selected', t.getAttribute('data-n-tab') === name ? 'true' : 'false'); });
      panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-n-pane') === name); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-n-tab')); }); });
    if (noApi) {
      var regTab = $('[data-n-tab="reg"]', root);
      if (regTab) regTab.setAttribute('hidden', '');
      showTab('manual');
      if (status) status.textContent = 'Choose your car below and we will show the right grade and specification.';
    }

    function setStatus(msg, isError) { if (!status) return; status.textContent = msg || ''; status.classList.toggle('is-error', !!isError); }

    function render(v) {
      var R = recommend(v);
      saveVehicle(v);
      var html = '';
      html += '<div class="n-result__vehicle">' + (v.reg ? '<span class="n-plate-mini">' + esc(prettyReg(v.reg)) + '</span>' : '') + '<div><strong>' + esc(vehicleLabel(v)) + '</strong><br><span>' + esc(vehicleSub(v)) + '</span></div><a class="n-link" href="' + esc(FINDER_URL) + '" data-n-reset>Not your vehicle? Search again</a></div>';
      if (R.vehicleType === 'ev') {
        html += '<div class="n-card n-rec"><div class="n-rec__label">Electric vehicle</div><div class="n-rec__spec">No engine oil needed</div><p class="n-rec__note">Fully electric cars have no engine oil to change. Reduction-gearbox and coolant fluids are dealer-specified items. You may still find our greases, penetrating sprays and brake lubricants useful.</p><a class="n-btn n-btn--primary" href="/collections/grease">Browse greases and sprays</a></div>';
      } else {
        html += '<div class="n-recs">';
        html += recCard(R.primary, 'Recommended grade', '');
        R.alts.forEach(function (a) { html += recCard(a, 'Also approved / alternative', 'n-rec--alt'); });
        html += '</div>';
        html += '<div class="n-result__products"><h2>' + esc(R.primary.grade) + ' oils for your ' + esc(titleCase(v.make)) + '</h2><p class="n-lead">Every product below carries a ' + esc(titleCase(v.make)) + ' approval or recommendation in the ' + esc(R.primary.grade) + ' grade. Match the specification code on the bottle to the one above.</p><div class="n-result__grid" data-n-grid><div class="n-skeleton"><div></div><div></div><div></div><div></div></div></div><p style="margin-top:1.6rem"><a class="n-btn n-btn--primary" href="' + esc(collUrl(R.primary)) + '">See all ' + esc(R.primary.grade) + ' ' + esc(titleCase(v.make)) + ' oils</a></p></div>';
        html += '<p class="n-result__disclaimer">Recommendations are based on the make, fuel type, year and engine size recorded for the vehicle and the manufacturer specifications current at the time of writing. Always confirm against your handbook or the oil filler cap, as different engines in the same model can require different oils. Unsure? <a href="/pages/contact">Send us your registration</a> and we will check it for you.</p>';
      }
      result.innerHTML = html;
      result.classList.add('is-visible');
      var reset = $('[data-n-reset]', result);
      if (reset) reset.addEventListener('click', function (e) { e.preventDefault(); clearVehicle(); result.classList.remove('is-visible'); result.innerHTML = ''; if (regInput) { regInput.value = ''; regInput.focus(); } window.history.replaceState({}, '', FINDER_URL); });
      if (R.primary) loadGrid($('[data-n-grid]', result), R.primary);
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function recCard(r, label, cls) {
      return '<div class="n-card n-rec ' + cls + '"><div class="n-rec__label">' + esc(label) + '</div><div class="n-rec__grade">' + esc(r.grade) + '</div><div class="n-rec__spec">' + esc(r.spec) + '</div><p class="n-rec__note">' + esc(r.note) + '</p><a class="n-btn n-btn--primary n-btn--sm" href="' + esc(collUrl(r)) + '">Shop ' + esc(r.grade) + ' oils</a></div>';
    }

    function loadGrid(host, r) {
      if (!host) return;
      var url = collUrl(r);
      fetch(url + '?section_id=nitroma-results-grid', { headers: { Accept: 'text/html' } })
        .then(function (res) { if (!res.ok) throw new Error('section'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-n-results]');
          if (!grid || !grid.querySelector('.card-wrapper, .n-mini')) throw new Error('empty');
          host.innerHTML = grid.innerHTML;
        })
        .catch(function () {
          fetch('/collections/' + r.collection + '/products.json?limit=250').then(function (res) { return res.json(); }).then(function (j) {
            var want = String(r.grade).toLowerCase();
            var items = (j.products || []).filter(function (p) { return (p.tags || []).some(function (t) { return String(t).toLowerCase() === want; }); }).slice(0, 8);
            if (!items.length) { host.innerHTML = '<p>No products matched automatically. <a href="' + esc(url) + '">Browse the collection</a> or <a href="/pages/contact">ask us</a>.</p>'; return; }
            host.innerHTML = '<ul class="n-grid n-grid--4" style="list-style:none;padding:0;margin:0">' + items.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0].src : '';
              var price = p.variants && p.variants[0] ? p.variants[0].price : '';
              return '<li class="n-card n-mini" style="padding:1.4rem"><a href="/products/' + esc(p.handle) + '" style="text-decoration:none;color:inherit">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:contain">' : '') + '<strong style="display:block;margin-top:.8rem;font-size:1.4rem">' + esc(p.title) + '</strong>' + (price ? '<span style="display:block;margin-top:.4rem;font-weight:800">&pound;' + esc(price) + '</span>' : '') + '</a></li>';
            }).join('') + '</ul>';
          }).catch(function () { host.innerHTML = '<p><a href="' + esc(url) + '">Browse matching oils</a></p>'; });
        });
    }

    function runReg(reg) {
      reg = cleanReg(reg);
      if (!reg) return;
      if (regInput) regInput.value = prettyReg(reg);
      setStatus('Looking up ' + prettyReg(reg) + '…');
      lookup(reg).then(function (v) {
        setStatus('');
        if (!v.make) { setStatus('We found the vehicle but not its make. Please use the make and model search instead.', true); showTab('manual'); return; }
        render(v);
        window.history.replaceState({}, '', FINDER_URL + '?reg=' + encodeURIComponent(reg));
      }).catch(function (err) {
        var code = err && err.code;
        if (code === 'no_api') { setStatus('Registration lookup is not switched on yet. Choose your car below instead.', true); showTab('manual'); }
        else if (code === 'bad_reg') { setStatus('That does not look like a UK registration. Please check and try again.', true); }
        else if (code === 'not_found') { setStatus('We could not find that registration with the DVLA. Check the plate, or choose your car below.', true); showTab('manual'); }
        else { setStatus('The lookup service did not respond. Please try again or choose your car below.', true); showTab('manual'); }
      });
    }

    if (regForm) regForm.addEventListener('submit', function (e) { e.preventDefault(); runReg(regInput.value); });
    if (manual) manual.addEventListener('submit', function (e) {
      e.preventDefault();
      var make = makeSel.value, fuel = fuelSel.value, year = parseInt(yearSel.value, 10);
      if (!make || !fuel || !year) { setStatus('Please choose a make, fuel type and year.', true); return; }
      setStatus('');
      render(normaliseVehicle({ make: make, fuelType: fuel, yearOfManufacture: year, engineCapacity: ccInput && ccInput.value ? Math.round(parseFloat(ccInput.value) * (parseFloat(ccInput.value) < 20 ? 1000 : 1)) : 0 }, ''));
      window.history.replaceState({}, '', FINDER_URL + '?make=' + encodeURIComponent(make) + '&fuel=' + encodeURIComponent(fuel) + '&year=' + year);
    });

    var q = {};
    window.location.search.replace(/^\?/, '').split('&').forEach(function (kv) { if (!kv) return; var p = kv.split('='); q[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' ')); });
    if (q.reg) { if (API) runReg(q.reg); else { if (regInput) regInput.value = prettyReg(q.reg); setStatus('Registration lookup is being connected. Choose your car below and we will show the right oil.', true); showTab('manual'); } }
    else if (q.make && q.fuel && q.year) { makeSel.value = q.make; fuelSel.value = q.fuel; yearSel.value = q.year; showTab('manual'); render(normaliseVehicle({ make: q.make, fuelType: q.fuel, yearOfManufacture: q.year }, '')); }
    else { var saved = loadVehicle(); if (saved && saved.make) render(saved); }
  }

  /* ---------------------------------------------------- product fit box */
  function initFit(box) {
    var tags = [];
    try { tags = JSON.parse(box.getAttribute('data-n-tags') || '[]'); } catch (e) {}
    var out = $('[data-n-fit-result]', box);
    var form = $('form', box);
    var input = form && $('input', form);
    var norm = function (s) { return String(s).toLowerCase().replace(/[\s.\-_]/g, ''); };
    var ntags = tags.map(norm);
    function show(v) {
      var R = recommend(v);
      if (!R.primary) { out.className = 'n-fit__result'; out.innerHTML = 'Electric vehicle: no engine oil needed.'; return; }
      var all = [R.primary].concat(R.alts);
      var hit = null, specHit = false;
      var makeTagged = v.group && ['generic', 'ev', 'truck'].indexOf(v.group) < 0 && tags.some(function (t) { return String(t).length <= 16 && makeGroup(t) === v.group; });
      all.forEach(function (r) { if (hit) return; var g = ntags.indexOf(norm(r.grade)) >= 0; var s = r.tokens.some(function (t) { var nt = norm(t); return ntags.some(function (x) { return x.indexOf(nt) >= 0; }); }); if (g && s) { hit = r; specHit = true; } });
      if (!hit && makeTagged) all.forEach(function (r) { if (hit) return; if (ntags.indexOf(norm(r.grade)) >= 0) hit = r; });
      var label = esc(vehicleLabel(v));
      if (hit && specHit) { out.className = 'n-fit__result is-ok'; out.innerHTML = '<strong>&#10003; Suitable for your ' + label + '</strong><br>This oil is a ' + esc(hit.grade) + ' that meets ' + esc(hit.spec) + ', the specification we recommend for your vehicle.'; }
      else if (hit) { out.className = 'n-fit__result is-ok'; out.innerHTML = '<strong>&#10003; Listed for ' + esc(titleCase(v.make)) + '</strong><br>This ' + esc(hit.grade) + ' is recommended for ' + esc(titleCase(v.make)) + ' engines. Your ' + label + ' normally needs ' + esc(hit.spec) + ': check that code appears in the specifications above or on the bottle.'; }
      else { out.className = 'n-fit__result is-warn'; out.innerHTML = '<strong>Check before you buy</strong><br>Your ' + label + ' normally needs ' + esc(R.primary.grade) + ' ' + esc(R.primary.spec) + '. <a href="' + esc(collUrl(R.primary)) + '">See oils that match &rarr;</a>'; }
    }
    var saved = loadVehicle();
    if (saved && saved.make) { if (input && saved.reg) input.value = prettyReg(saved.reg); show(saved); }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var reg = cleanReg(input.value);
      if (!reg) return;
      if (!API) { window.location.href = FINDER_URL + '?reg=' + encodeURIComponent(reg); return; }
      out.className = 'n-fit__result'; out.textContent = 'Checking ' + prettyReg(reg) + '…';
      lookup(reg).then(function (v) { saveVehicle(v); show(v); }).catch(function () { out.className = 'n-fit__result is-warn'; out.innerHTML = 'We could not look that registration up. <a href="' + esc(FINDER_URL) + '">Use the oil finder</a> to choose your car manually.'; });
    });
  }

  function init() {
    renderHeaderPill();
    bindPlateForms();
    $$('[data-n-finder]').forEach(initFinder);
    $$('[data-n-fit]').forEach(initFit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.NitromaFinder = window.NitromaFinder || {};
  window.NitromaFinder.recommend = recommend;
  window.NitromaFinder.makeGroup = makeGroup;
})();
